import { render } from "./MaestroCentros.vue?vue&type=template&id=7cc8c4da"
import script from "./MaestroCentros.vue?vue&type=script&lang=js"
export * from "./MaestroCentros.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__